<template>
<div class="park-page" v-if="isSmallScreen===false">
<headers :imageSrc="imageSrc"/>
<mains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<bottom/>
</div>
<div class="park-page" v-else>
<headers :imageSrc="imageSrc"/>
<parkmains :res1="res1" :res2="res2" :res3="res3" :res4="res4" :res5="res5"/>
<parkbottom/>
</div>
</template>
<script>
import headers from '../../components/headers.vue'
import parkbottom from '@/components/parkbottom.vue'
import Parkmains from '../../components/parkmains.vue'
import mains from '@/components/mains'
import bottom from '@/components/bottom'
export default {
  components: { headers, parkbottom, Parkmains, mains, bottom },
  data () {
    return {
      isSmallScreen: false,
      imageSrc: '../assets/image/yqltdnbanners.png',
      res1: '碳立方-园区零碳大脑',
      res2: '以碳中和理念为指导，依托园区碳中和模型，以物理空间和数字空间融合为承载，以数据打通园区核心生产要素各环节，对园区碳排放重点要素数据进行全量汇聚，建立园区碳排放指标体系和碳',
      res3: '管控应用，保障零碳智慧园区建设目标顺利推进和愿景落地。',
      res4: '一：某煤基产业园区零碳大脑项目  /  二：某信息港智能制造产业园零碳大脑项目',
      res5: '../assets/2023logoImage/tlf_yqltdn.png'
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      // this.res5 = '../assets/footprint/tlf_qyltdn_tzjb.png'
      this.imageSrc = '../assets/image/yqltdnbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      // this.res5 = '../assets/footprint/tlf_qyltdn_tzjb.png'
      this.imageSrc = '../assets/image/yqltdnbanner.png'
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>

<style scoped>

</style>
